/**
 * Light ATC confetti burst (JazzCandy brand colors).
 * Enabled via theme setting sc_atc_confetti; listens to cart-update from add sources.
 */
(() => {
  const ADD_SOURCES = new Set(['product-form', 'sc-upsell-add', 'quick-add']);
  const COLORS = ['#f20090', '#334fb4', '#ff6b9d', '#ffd166', '#ffffff', '#7eb8ff', '#ff9ecd'];
  const PARTICLE_COUNT = 48;
  const DURATION_MS = 1400;
  const GRAVITY = 0.18;
  const DRAG = 0.985;

  let origin = { x: null, y: null };
  let canvas = null;
  let ctx = null;
  let rafId = 0;
  let particles = [];
  let running = false;

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function ensureCanvas() {
    if (canvas) return;
    canvas = document.createElement('canvas');
    canvas.id = 'sc-atc-confetti';
    canvas.className = 'sc-atc-confetti';
    canvas.setAttribute('aria-hidden', 'true');
    document.body.appendChild(canvas);
    ctx = canvas.getContext('2d');
    resize();
    window.addEventListener('resize', resize, { passive: true });
  }

  function resize() {
    if (!canvas) return;
    const dpr = Math.min(window.devicePixelRatio || 1, 2);
    canvas.width = Math.floor(window.innerWidth * dpr);
    canvas.height = Math.floor(window.innerHeight * dpr);
    canvas.style.width = `${window.innerWidth}px`;
    canvas.style.height = `${window.innerHeight}px`;
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
  }

  function captureOrigin(event) {
    const target = event.target;
    if (!(target instanceof Element)) return;

    const submit =
      target.closest('button[name="add"], button[type="submit"].product-form__submit, sc-upsell-add button[type="submit"]') ||
      (target.closest('form[data-type="add-to-cart-form"]') &&
        target.closest('form').querySelector('[type="submit"]'));

    if (!submit) return;

    const rect = submit.getBoundingClientRect();
    origin = {
      x: rect.left + rect.width / 2,
      y: rect.top + rect.height / 2,
    };
  }

  function createParticle(x, y) {
    const angle = -Math.PI / 2 + (Math.random() - 0.5) * Math.PI * 1.15;
    const speed = 6 + Math.random() * 9;
    const shapeRoll = Math.random();

    return {
      x,
      y,
      vx: Math.cos(angle) * speed + (Math.random() - 0.5) * 3,
      vy: Math.sin(angle) * speed - Math.random() * 4,
      w: 4 + Math.random() * 6,
      h: 6 + Math.random() * 10,
      rotation: Math.random() * Math.PI * 2,
      spin: (Math.random() - 0.5) * 0.35,
      color: COLORS[(Math.random() * COLORS.length) | 0],
      shape: shapeRoll < 0.45 ? 'rect' : shapeRoll < 0.75 ? 'circle' : 'strip',
      opacity: 1,
      life: 0,
      ttl: 0.65 + Math.random() * 0.35,
    };
  }

  function drawParticle(p) {
    ctx.save();
    ctx.translate(p.x, p.y);
    ctx.rotate(p.rotation);
    ctx.globalAlpha = p.opacity;
    ctx.fillStyle = p.color;

    if (p.shape === 'circle') {
      ctx.beginPath();
      ctx.arc(0, 0, p.w * 0.45, 0, Math.PI * 2);
      ctx.fill();
    } else if (p.shape === 'strip') {
      ctx.fillRect(-p.w * 0.2, -p.h / 2, p.w * 0.4, p.h);
    } else {
      ctx.fillRect(-p.w / 2, -p.h / 2, p.w, p.h);
    }

    ctx.restore();
  }

  function tick(now) {
    if (!running) return;

    const start = tick.start || (tick.start = now);
    const elapsed = now - start;
    const progress = Math.min(elapsed / DURATION_MS, 1);

    ctx.clearRect(0, 0, window.innerWidth, window.innerHeight);

    for (let i = 0; i < particles.length; i++) {
      const p = particles[i];
      p.vy += GRAVITY;
      p.vx *= DRAG;
      p.vy *= DRAG;
      p.x += p.vx;
      p.y += p.vy;
      p.rotation += p.spin;
      p.life = progress / p.ttl;
      p.opacity = Math.max(0, 1 - Math.max(0, p.life - 0.55) / 0.45);
      drawParticle(p);
    }

    if (progress < 1) {
      rafId = requestAnimationFrame(tick);
    } else {
      running = false;
      tick.start = 0;
      ctx.clearRect(0, 0, window.innerWidth, window.innerHeight);
      particles = [];
    }
  }

  function burst(x, y) {
    if (prefersReducedMotion()) return;

    ensureCanvas();
    const ox = Number.isFinite(x) ? x : window.innerWidth / 2;
    const oy = Number.isFinite(y) ? y : window.innerHeight * 0.45;

    particles = Array.from({ length: PARTICLE_COUNT }, () => createParticle(ox, oy));
    running = true;
    tick.start = 0;
    cancelAnimationFrame(rafId);
    rafId = requestAnimationFrame(tick);
  }

  function onCartUpdate(event) {
    if (!event || !ADD_SOURCES.has(event.source)) return;

    const x = Number.isFinite(origin.x) ? origin.x : window.innerWidth / 2;
    const y = Number.isFinite(origin.y) ? origin.y : window.innerHeight * 0.45;
    burst(x, y);
  }

  document.addEventListener('pointerdown', captureOrigin, true);

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, onCartUpdate);
  }

  window.scAtcConfetti = { burst };
})();
